import templateUrl from './payroll-invoice-policy-list.component.html';
import { EditPayrollInvoicePolicyModal } from '../edit-payroll-invoice-policy/edit-payroll-invoice-policy-modal.component';
import { EmployeeService } from '../../../core/services';
import { IQService } from 'angular';
import { UtilityService } from '../../../core/services/utility.service';

export const PayrollInvoicePolicyListComponent = {
    templateUrl,
    controller: PayrollInvoicePolicyListController,
    controllerAs: "vm",
    bindings: {}
};

function PayrollInvoicePolicyListController($q: IQService, $uibModal, employeeService: EmployeeService,
    payrollInvoicePolicyService, utilityService: UtilityService) {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = activate;
    vm.onEdit = onEdit;
    vm.onDelete = onDelete;
    vm.payrollInvoicePolicies;

    function activate() {
        const permissions = employeeService.retrievePermissions({
            stateName: "payout.payoutPolicyList"
        });
        const policies = getPayrollInvoicePolicies();
        const loaded = $q.all([permissions, policies])
            .then(([permissions, policies]) => {
                vm.payrollInvoicePolicies = policies;
                vm.roleAccess = permissions;
            });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loaded, "Initial load failed")
        );
    }

    function onEdit(policy) {
        // Create a copy of the policy so it doesn't update in the page.
        const editablePolicy = policy ? {
            PayrollInvoicePolicyID: policy.PayrollInvoicePolicyID,
            Name: policy.Name,
            FlatFee: policy.FlatFee
        } : {};
        $uibModal.open({
            ...EditPayrollInvoicePolicyModal,
            resolve: {
                payrollInvoicePolicy:  () => editablePolicy,
                saveFn: () => onSave
            }
        }).result.then(onReload);
    }

    function onSave(policy) {
        utilityService.showLoading();
        return payrollInvoicePolicyService.savePayrollInvoicePolicy(policy)
            .catch(function (ex) {
                console.error(ex);
                alert("Save failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(utilityService.hideLoading);
    }

    function onReload() {
        utilityService.showLoading();
        return payrollInvoicePolicyService.retrievePayrollInvoicePolicies()
            .then(function (policies) {
                vm.payrollInvoicePolicies = policies;
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Reload failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function onDelete(policy) {
        if (!confirm("The policy will be deleted.")) {
            return;
        }
        utilityService.showLoading();
        payrollInvoicePolicyService.deletePayrollInvoicePolicy(policy.PayrollInvoicePolicyID)
            .catch(function (ex) {
                console.error(ex);
                alert("Delete failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(utilityService.hideLoading)
            .then(onReload);
    }

    function getPayrollInvoicePolicies() {
        if (vm.payrollInvoicePolicies) {
            return $q.when(vm.payrollInvoicePolicies);
        } else {
            return payrollInvoicePolicyService.retrievePayrollInvoicePolicies();
        }
    }
}
